export const settingsSectionSlugs = [
  'categories-operations',
  'scoring-trails',
  'sharing',
  'connection',
  'display',
  'data-backup',
  'scoreboard-display',
  'public-wall-display',
  'timeline-structure',
] as const

export type SettingsSectionSlug = (typeof settingsSectionSlugs)[number]

export function readSettingsSection(search: string): SettingsSectionSlug | null {
  const candidate = new URLSearchParams(search).get('section')
  return settingsSectionSlugs.includes(candidate as SettingsSectionSlug) ? candidate as SettingsSectionSlug : null
}

export function settingsHref(section: SettingsSectionSlug | null, search = ''): string {
  const params = new URLSearchParams(search)
  params.set('screen', 'settings')
  if (section) params.set('section', section)
  else params.delete('section')
  return `/?${params.toString()}`
}

export function timelineHref(search = ''): string {
  const params = new URLSearchParams(search)
  params.set('screen', 'timeline')
  params.delete('section')
  return `/?${params.toString()}`
}
